export default {
      id: "md_traffic-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.svg#md_traffic",
      toString: function () {
        return this.url;
      }
    }